import { api, handleApiError } from './apiConfig';

// Reading API service for article read status and feedback
export const readingApi = {
  // Get article details for feedback (no authentication required)
  getArticleDetails: async (email, articleId) => {
    try {
      const response = await api.get(`/api/article-details/${encodeURIComponent(email)}/${articleId}`);
      return response.data;
    } catch (error) {
      const errorMessage = handleApiError(error, 'Failed to get article details');
      throw new Error(errorMessage);
    }
  },

  // Submit feedback for an article
  submitFeedback: async (feedbackData) => {
    try {
      const response = await api.post('/api/submit-feedback', feedbackData);
      return response.data;
    } catch (error) {
      const errorMessage = handleApiError(error, 'Failed to submit feedback');
      throw new Error(errorMessage);
    }
  },

  // Get reading stats for a user (no authentication required)
  getReadingStats: async (email) => {
    try {
      const response = await api.get(`/api/reading-stats/${encodeURIComponent(email)}`);
      return response.data;
    } catch (error) {
      const errorMessage = handleApiError(error, 'Failed to fetch reading statistics');
      throw new Error(errorMessage);
    }
  }
};
